import { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import s from './Overview.scss'
import { AllDashboardComponent } from '../DictionaryDashboard'
import { OverviewNewModalContainer } from 'components/Dashboard/modals/OverviewNewModal'
import { ComponentSpinner } from '../ComponentSpinner'
import { getCurrency } from 'utils/authService'
import pluralize from 'pluralize'
import { stageTotalValue, stageTotalCount, round2decimals } from './serializers'
import { NumericFormat } from 'react-number-format'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class OverviewContainer extends Component {
  state = {
    showOverviewNewModal: false
  }

  toggleOverviewNewModal = () => {
    this.setState(prevState => ({ showOverviewNewModal: !prevState.showOverviewNewModal }))
  }

  openModal = () => {
    this.setState({ showOverviewNewModal: true })
  }

  render() {
    const { type, officeId, userId, isAdmin, layoutLocked } = this.props
    const { overview } = this.props.dashboard
    const { showOverviewNewModal } = this.state
    const { symbol } = getCurrency()
    return (
      <>
        {Object.keys(overview).length === 0 && <ComponentSpinner />}
        <OverviewNewModalContainer
          onClick={this.toggleOverviewNewModal}
          showOverviewNewModal={showOverviewNewModal}
          title={AllDashboardComponent[type].label}
          tableHeaderStyle={{
            backgroundColor: overview[AllDashboardComponent[type]?.label]?.color
          }}
          officeId={officeId}
          userId={userId}
          isAdmin={isAdmin}
          stage={AllDashboardComponent[type].label}
        />
        <div
          onClick={() => {
            if (layoutLocked) this.openModal()
          }}
          className={cn(s.overviewWrapper)}
          style={{ backgroundColor: overview[AllDashboardComponent[type]?.label]?.color }}
        >
          <div className={s.overviewTitle}>{AllDashboardComponent[type].label}</div>
          {Object.keys(overview).length !== 0 && (
            <>
              <div className={s.overviewAmount}>
                <NumericFormat
                  value={round2decimals(
                    stageTotalValue(overview[AllDashboardComponent[type].label].dealStatuses)
                  )}
                  displayType="text"
                  thousandSeparator
                  prefix={symbol}
                />
                {' - '}
                <span className={s.overviewDeals}>
                  {pluralize(
                    'opp',
                    stageTotalCount(overview[AllDashboardComponent[type].label].dealStatuses),
                    true
                  )}
                </span>
              </div>
              <div className={s.dealStatusesList}>
                {overview[AllDashboardComponent[type].label].dealStatuses.map(status => (
                  <div className={s.dealStatus} key={status.dealStatusName}>
                    <div>{status.dealStatusName}</div>
                    <div>
                      <NumericFormat
                        value={status.value}
                        displayType="text"
                        thousandSeparator
                        prefix={symbol}
                      />{' '}
                      <span className={s.overviewDeals}>
                        {pluralize('opp', status.count, true)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </>
    )
  }
}

export default OverviewContainer
